import { gql } from '@apollo/client';

export const UPDATE_PATIENT_STAFF = gql`
  mutation updatePatientUser($data: UpdatePatientUserInput!) {
    updatePatientUser(data: $data)
  }
`;
